/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {error, info} from '../logger/logger';

// Provides the Dynatrace initialization success logger ...
export const logInitializeSuccess = () => {
  info(_messages.initialize.success);
};

// Provides the Dynatrace initialization error logger ...
export const logInitializeError = () => {
  error(_messages.initialize.error);
};

// Provides the Dynatrace initialization dependency error logger ...
export const logInitializeDependencyError = () => {
  error(_messages.initialize.dependency);
};

// Provides the Dynatrace initialization already available error logger ...
export const logInitializeAvailableError = () => {
  error(_messages.initialize.available);
};

// Provides the Dynatrace identify user success logger ...
export const logIdentifyUserSuccess = () => {
  info(_messages.identifyUser.success);
};

// Provides the Dynatrace identify user error logger ...
export const logIdentifyUserError = () => {
  error(_messages.identifyUser.error);
};

// Provides the Dynatrace identify user not initialized error logger ...
export const logIdentifyUserInitializationError = () => {
  error(_messages.identifyUser.notInitialized);
};

// Provides the Dynatrace report error success logger ...
export const logReportErrorSuccess = () => {
  info(_messages.reportError.success);
};

// Provides the Dynatrace report error failure logger ...
export const logReportErrorFailure = () => {
  error(_messages.reportError.error);
};

// Provides the Dynatrace report custom error success logger ...
export const logReportCustomErrorSuccess = () => {
  info(_messages.reportCustomError.success);
};

// Provides the Dynatrace report custom error failure logger ...
export const logReportCustomErrorFailure = () => {
  error(_messages.reportCustomError.error);
};

// Provides a basic abstraction of Dynatrace log messages from API implementation.
export const _messages = {
  initialize : {
    success    : 'Dynatrace.initialize has completed successfully. RUM monitoring initialization complete.',
    error      : 'Dynatrace.initialize has failed, dtrum API is not available.',
    dependency : 'Dynatrace.initialize failed, OneAgent dependency has not been loaded.',
    available  : 'Dynatrace.initialize has previously been invoked, dtrum is already available.'
  },
  identifyUser : {
    success        : 'Dynatrace.identifyUser has completed successfully.',
    error          : 'Dynatrace.identifyUser has failed, dtrum API is not available.',
    notInitialized : 'Dynatrace.identifyUser can not be invoked until after Dynatrace.initialize has been called.'
  },
  reportError : {
    success : 'Dynatrace.reportError logged successfully.',
    error   : 'Dynatrace.reportError logging failed.'
  },
  reportCustomError : {
    success : 'Dynatrace.reportCustomError logged successfully.',
    error   : 'Dynatrace.reportCustomError logging failed.'
  }
};
